module.exports = __webpack_public_path__ + "assets/images/magenta_sport_highlights.a4de357ab51d992d44113523ef6be413.png";